var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 29a3 3 0 01-3 3H3a3 3 0 01-3-3V12.545a3 3 0 011.15-2.36C2.705 8.963 3.992 7.973 11.411 2.59 12.463 1.823 14.55-.022 16 0c1.45-.022 3.537 1.823 4.588 2.59 7.418 5.383 8.707 6.374 10.263 7.594A3 3 0 0132 12.545V29zm-4.104-12.288a.5.5 0 00-.709-.119 1028.961 1028.961 0 01-6.599 4.817C19.537 22.177 17.45 24.022 16 24c-1.45.021-3.535-1.822-4.588-2.59-3.132-2.273-5.171-3.762-6.6-4.817a.5.5 0 00-.708.12l-.567.824a.5.5 0 00.115.685c1.43 1.057 3.466 2.543 6.581 4.805C11.502 23.95 13.766 26.015 16 26c2.233.015 4.498-2.048 5.766-2.973 3.116-2.262 5.152-3.748 6.582-4.805a.5.5 0 00.115-.685l-.567-.825z",
    fill: "#FFA852"
  })));
}

export default SvgLetter;